<template>
  <b-modal
    id="flashMessagesModal"
    size="md"
    title="Системные сообщения"
    hide-footer
    modal-class="main-modal main-block"
    header-class="text-white border-0"
    header-close-variant="orange"
    title-class="text-center underlined-muted-title"
    body-class="pt-0"
    content-class="border-0"
  >
    <div v-if="flashMessages" class="col-12 px-0 new-messages-area">
      <div
        v-for="(message ,messageIndex) in flashMessages.messages"
        :id="'new_message_'+messageIndex"
        :key="messageIndex"
        class="form-group mb-3 py-2  pl-3 pr-2 message-item white-color"
      >
        <div class="row mx-0 message-text-area w-100">
          <p class="message-text" v-html="message"></p>
        </div>
      </div>
    </div>
    <div class="col-12 px-0 text-right">
      <a
        class="btn mark-new-as-read"
        title="Пометить как прочитанное"
        @click.prevent="readFlashMessages"
      >
        <i class="fa fa-spin fa-spinner" v-if="requesting"></i>
        <i class="fa fa-envelope" v-else></i>
      </a>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
import Config from "@/config";

export default {
  name: 'FlashMessages',
  data() {
    return {
      requesting: false
    }
  },
  computed: {
    flashMessages () {
      return this.$store.getters.getFlashMessages
    }
  },
  methods: {
    readFlashMessages () {
      this.requesting = true
      axios.get(Config.baseUrl + '/Api/unsetFlashMessages', {
        withCredentials:true
          }
      ).then(() => {
        this.requesting = false
        this.$store.commit('setFlashMessages', null)
      })
    }
  },
  mounted () {
    if (this.flashMessages) {
      this.$root.$emit('bv::show::modal', 'flashMessagesModal')
    }
    axios.get(Config.baseUrl + '/Api/unsetFlashMessages', {
          withCredentials:true
        }
    )
  }
}
</script>

<style scoped>
  .fa-spinner{
    font-size: 19px;
  }
</style>
